export default __webpack_public_path__ + "static/media/download.cdbdba7a.png";